import { useOracleSearchStore } from '@modules/oracle/store/oracleSearchStore';

export function useGetPromptPosition(promptID: string | undefined) {
  const promptByID = useOracleSearchStore(({ data }) => data.promptByID);

  let position = 0;

  if (!promptID) {
    return position;
  }

  let currentPrompt = promptByID?.[promptID];
  while (currentPrompt?.previousResponseID) {
    position++;
    currentPrompt = promptByID?.[currentPrompt.previousResponseID];
  }

  return position;
}
